import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TreeNode } from '../../models/tree-models';

@Component({
  selector: 'app-fs-toolbar',
  templateUrl: './filesystem-toolbar.component.html',
  styleUrls: ['./filesystem-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilesystemToolbarComponent {
  @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef;
  @Input() activeNode: TreeNode;
  @Input() activeToolbarAction: boolean = false;
  @Input() moveFiletoggle: boolean = false;
  @Input() selectedNodes: TreeNode[];
  @Output() iconActionHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() uploadHandler: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  iconClick = (action: string) => this.iconActionHandler.emit({ action, element: this.fileUpload });

  uploadFile = (event: any) => this.uploadHandler.emit(event);

  cleanInput = (event: any) => (event.target.value = null);
}
